'use client';

import { useRootPageRedirection } from '../utils/hook/useRootPageRedirection';
import LoadingPage from './LoadingPage';

/**
 * 루트 페이지 (/)
 *
 * 리다이렉션 우선순위:
 * - 비로그인 사용자 → /main (ManualPage)
 * - 정기배송 이력 있음 → /subscriptions/{id}/main (대표 구독 우선)
 * - 정기배송 이력 없음 또는 에러 → /main (Graceful Degradation)
 */
const RootRedirectPage = () => {
  useRootPageRedirection();

  return <LoadingPage />;
};

export default RootRedirectPage;
